import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { RailItemResponse } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import { VideoFormatter } from '@/helpers/video-formatter';
import TG4Image from '@/components/TG4Image.vue';
import TG4PlayIcon from '@/components/TG4PlayIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SplitPanelItem',
  props: {
    item: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: RailItemResponse;
};






const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const isIrish = computed(() => currentLanguage.value === Language.Irish);

const category = computed(() => (props.item.type === 'CATEGORY' ? props.item.category : null));

const categoryLabel = computed(() => {
  const value = category.value;
  if (!value) return '';
  return (isIrish.value ? value.displayGa : value.displayEn) ?? value.displayEn ?? '';
});

// Pink when the CMS has not picked a colour, matching the other platforms.
const categoryStyle = computed(() => ({
  'background-color': category.value?.color ?? undefined,
}));

const image = computed(() => {
  const item = props.item;
  if (item.type === 'SERIES') return item.series.mainImage;
  if (item.type === 'VIDEO') return item.video.image;
  return null;
});


const itemSubtitle = computed(() => {
  const item = props.item;
  if (item.type === 'SERIES') return "";
  if (item.type === 'VIDEO') return item.video.seriesTitle ?? item.video.displayTitle ?? '';
  return '';
});

const itemTitle = computed(() => {
  const item = props.item;
  if (item.type === 'SERIES') return item.series.name;
  if (item.type === 'VIDEO') return VideoFormatter.getEpisodeCellSubtitle(item.video) ?? '';
  return '';
});

return { __sfc: true,props, emit, useGetter, currentLanguage, isIrish, category, categoryLabel, categoryStyle, image, itemSubtitle, itemTitle, TG4Image, TG4PlayIcon }
}

})